import React, { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../../api/KeyNames';
import { ErrorConnection } from '../../../../Components/Error/Error';
import { Loading } from '../../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../../Components/Context/FeedbackContext";
import * as PathNames from '../../../../api/PathNames';
import { generateToken } from '../../../../Components/Utils/Utils';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import PermissionsGate from '../../../../../app/api/PermissionsGate';
import { useRanger } from "react-ranger";
import styled from "styled-components";



export default function AddCategoria({ currentCategory, showEditCategoria, setShowEditCategoria, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [newCategoria, setNewCategoria] = useState(null);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const [values, setValues] = useState([null, null]);

    useEffect(() => {
        setValues([currentCategory?.semaforo?.verde?.hasta, currentCategory?.semaforo?.amarillo?.hasta]);
    }, [currentCategory])

    const onSubmit = dataNewCategoria => {
        setNewCategoria({
            ...dataNewCategoria,
            categoriaId: currentCategory.value,
            verdeMin: 0,
            verdeMax: values[0],
            amarilloMin: values[0] + 1,
            amarilloMax: values[1],
            rojoMin: values[1] + 1 > 100 ? 100 : values[1] + 1,
            rojoMax: 100
        }
        );
        setShowEditCategoria(false);
    };
    const token = useGetToken();

    const Track = styled("div")`
                    display: inline-block;
                    height: 8px;
                    width: 90%;
                    margin: 0 5%;
                    `;

    const Tick = styled("div")`
        :before {
            content: "";
            position: absolute;
            left: 0;
            background: rgba(0, 0, 0, 0.2);
            height: 5px;
            width: 2px;
            transform: translate(-50%, 0.7rem);
        }
    `;

    const TickLabel = styled("div")`
    position: absolute;
    font-size: 12px;
    color: #000;
    top: 100%;
    transform: translate(-50%, 1.2rem);
    white-space: nowrap;
    `;

    const Segment = styled("div")`
            background: ${props =>
            props.index === 0
                ? "green"
                : props.index === 1
                    ? "yellow"
                    : "red"};
            height: 100%;
            `;

    const Handle = styled("div")`
    background: #eeeffb !important;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 2rem !important;
    height: 2rem !important;
    border-radius: 100%;
    font-size: 13px !important;
    font-weight: 800 !important;
    line-height: 13px !important;
    white-space: nowrap;
    color: #434df4;
                    transform: ${props =>
            props.active ? "translateY(-100%) scale(1.2)" : "translateY(0) scale(0.9)"};
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                `;


    const { getTrackProps, ticks, segments, handles } = useRanger({
        min: 0,
        max: 100,
        stepSize: 1,
        values,
        onChange: setValues
    });




    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, newCategoria],
        async () => await Api.MapaCalorAllIn_EditCategory(
            { newCategoria: newCategoria, token }
        ),
        {
            enabled: Boolean(newCategoria)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 101 });
                reset(null);
                setNewCategoria(null);
                setRefreshData(true);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <Modal show={showEditCategoria} onHide={() => setShowEditCategoria(false)} animation={false} aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar Categoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>

                    <div className="fv-row mb-7 ">
                        <label className="required fw-bold fs-6 mb-2">Nombre de la categoría</label>
                        <input type="text" {...register("nombre", { required: true, value: currentCategory.label })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Nombre" />
                        <>{errors.nombre && <span className="text-danger">Ingresar el nombre de la categoría</span>}</>
                    </div>

                </form>
                <>
                    <label className="fw-bold fs-6 mb-2">Rangos:</label>
                    <div className="fv-row mb-7 ">
                        <Track {...getTrackProps()}>
                            {ticks.map(({ value, getTickProps }) => (
                                <Tick {...getTickProps()}>
                                    <TickLabel>{value}</TickLabel>
                                </Tick>
                            ))}
                            {segments.map(({ getSegmentProps }, i) => (
                                <Segment {...getSegmentProps()} index={i} />
                            ))}
                            {handles.map(({ value, active, getHandleProps }) => (
                                <button
                                    {...getHandleProps({
                                        style: {
                                            appearance: "none",
                                            border: "none",
                                            background: "transparent",
                                            outline: "none"
                                        }
                                    })}
                                >
                                    <Handle active={active}>{value}</Handle>
                                </button>
                            ))}
                        </Track>
                    </div>
                </>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secundary" onClick={() => setShowEditCategoria(false)}>Descartar</Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)}>Guardar</Button>
            </Modal.Footer>
        </Modal >
    )
}
